<template>
    <form class="px-3 pb-3" id="formTrocaSenha">
        
        <div class="form">
            <div class="row mb-3">
                <div class="col-8 col-md-8">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Email</label>
                        <input type="email" class="form-control" id="dsEmail" name="user.dsEmail" v-model="user.dsEmail" maxlength="100" required>
                    </div>
                </div>
                <div class="col-4 col-md-4">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Telefone</label>
                        <vue-mask class="form-control"
                                  id="nrTelefone"
                                  name="user.nrTelefone"
                                  v-model="user.nrTelefone"
                                  mask="(00) 00000-0000"
                                  :raw="false"
                                  required>
                        </vue-mask>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-8 col-md-8">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Nome</label>
                        <input type="text" class="form-control" id="nmUsuario" name="user.nmUsuario" v-model="user.nmUsuario" maxlength="100" required>
                    </div>


                </div>
                <div class="col-4 col-md-4">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Celular</label>
                        <vue-mask class="form-control"
                                  id="dsCelular"
                                  name="user.dsCelular"
                                  v-model="user.dsCelular"
                                  mask="(00) 00000-0000"
                                  :raw="false"
                                  required>
                        </vue-mask>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-4 col-md-4">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">CEP</label>
                        <vue-mask class="form-control"
                                  id="dsCep"
                                  name="user.dsCep"
                                  v-model="user.dsCep"
                                  mask="00000-000"
                                  :raw="false"
                                  :options="optionsCep"
                                  @blur="buscaCep"
                                  required>
                        </vue-mask>
                    </div>
                </div>
                <div class="col-8 col-md-8">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Edereço</label>
                        <input class="form-control" type="text" id="dsEndereco" placeholder="" v-model="user.dsEndereco" required />
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">UF</label>
                        <input class="form-control" type="text" id="nmUf" placeholder="" v-model="user.nmUf" required />
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Cidade</label>
                        <input class="form-control" type="text" id="nmCidade" placeholder="" v-model="user.nmCidade" required />
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Número</label>
                        <input class="form-control" type="text" id="nrNumero" placeholder="" v-model="user.nrNumero" required />
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Complemento</label>
                        <input class="form-control" type="text" id="dsComplemento" placeholder="" v-model="user.dsComplemento" required />
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Senha</label>
                        <input class="form-control" type="password" id="dsSenha" placeholder="Senha" v-model="user.dsSenha" required />
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16">Confirma Senha</label>
                        <input class="form-control" type="password" id="dsSenhaConfirma" placeholder="Confirme a Senha" v-model="user.dsSenhaConfirma" required />
                    </div>
                </div>
            </div>
        </div>

        <div class="row ">
            <div class="form-group w-100">
                <button class="btn btn-blue w-100" type="button" :disabled="!liberaSalvar" @click="enviar">Criar conta</button>
            </div>
        </div>

    </form>
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoErro /*,idModulo*/ } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Cadastro',
        components: {
            vueMask,
        },
        data: function () {
            return {

                limiteCaracteres: 500,

                user: {
                    nmUsuario: "",
                    dsEmail: "",
                    CpfCnpj: "",
                    dtNascimento: "",
                    nrTelefone: "",
                    dsCelular: "",
                    dsCep: "",
                    dsEndereco: "",
                    nrNumero: "",
                    dsComplemento: "",
                    dsBairro: "",
                    nmCidade: "",
                    nmUf: "",
                    dsSenha: "",
                    dsSenhaConfirma: "",
                },

                optionsDate: {
                    placeholder: '__/__/____',
                },

                optionsCpf: {
                    placeholder: '',
                },

                optionsTelefone: {
                    placeholder: '',
                },

                optionsCelular: {
                    placeholder: '',
                },

                optionsCep: {
                    placeholder: '',
                },

            }
        },
        props: {
            resposta: Function,
        },
        computed: {
            liberaSalvar() {
                
                if (this.user.dsSenha == '' || this.user.dsSenha == null) {
                    return false;
                }

                if (this.user.dsSenhaConfirma == '' || this.user.dsSenhaConfirma == null) {
                    return false;
                }
                return true;
            }
        },
        methods: {
            enviar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Utilidade/CadastroMural`, $this.user)
                        .then(res => {
                            if (res.data.success) {
                                $this.resposta($this.user);
                            } else {
                                avisoErro(res.data.msg);
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data.msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }

                return false;
            },

            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.user.dsSenha != this.user.dsSenhaConfirma) {
                    avisoErro("As senhas informadas não coincidem");
                }

                return true;
            },

            load() {
                this.user = {
                    nmUsuario: "",
                    dsEmail: "",
                    CpfCnpj: "",
                    dtNascimento: "",
                    nrTelefone: "",
                    dsCelular: "",
                    dsCep: "",
                    dsEndereco: "",
                    nrNumero: "",
                    dsComplemento: "",
                    dsBairro: "",
                    nmCidade: "",
                    nmUf: "",
                    dsSenha: "",
                    dsSenhaConfirma: "",
                };
            },

            close() {
                this.$refs['modal-cadastro'].hide();
            },

            buscaCep() {
                let $this = this;
                var cep = $this.user.dsCep.replace("-", "");
                if (cep != "") {
                    axios.get(`${urlApi}/Utilidade/GetDadosEndereco/${cep}`, { showLoading: false })
                        .then(res => {
                            if (res.data.success) {
                                if (res.data.data != null) {
                                    var dados = res.data.data[0];

                                    if (dados != null) {
                                        $this.user.dsEndereco = dados.dsEndereco;
                                        $this.user.nmUf = dados.nmUf;
                                        $this.user.nmCidade = dados.nmCidade;
                                        $this.user.nmBairro = dados.nmBairro;

                                    }

                                }
                            }
                        })
                        .catch(function () {
                            avisoErro("Não foi possível verificar o cep")
                        });
                }
            },

        },
        created: function () {
            this.load();
        },
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Cadastro */
   .form-control {
    }
</style>

